import shp from 'shpjs'
export default class GeoJsonAdapter {
  _file = null

  constructor (file) {
    this._file = file
  }

  _isKml (file) {
    return file.type === 'application/vnd.google-earth.kml+xml' || file.name.toLowerCase().includes('.kml')
  }

  _isZip (file) {
    return file.type === 'application/zip' || file.name.toLowerCase().includes('.zip')
  }

  _isGeoJSON (file) {
    return file.type === 'application/geo+json' || file.type === 'application/json' || file.name.toLowerCase().includes('.geojson')
  }

  _kmlMultiPolygonToGeoJSON (multiGeometry, properties) {
    const features = []
    const polygons = multiGeometry.getElementsByTagName('Polygon')
    if (polygons.length > 0) {
      const coordinates = []

      Array.from(polygons).forEach(polygon => {
        const coordsText = polygon.getElementsByTagName('coordinates')[0]?.textContent || ''
        const coords = coordsText
          .trim()
          .split(/\s+/)
          .filter(coord => coord.trim() !== '')
          .map(coord => {
            const [lng, lat] = coord.split(',').map(Number)
            return [lng, lat]
          })

        if (coords.length >= 3) {
          coordinates.push([coords])
        }
      })

      if (coordinates.length > 0) {
        features.push({
          type: 'Feature',
          properties,
          geometry: {
            type: 'MultiPolygon',
            coordinates
          }
        })
      }
    }

    return features
  }

  _kmlPolygonToGeoJson (placemark, properties) {
    const features = []
    const polygon = placemark.getElementsByTagName('Polygon')[0]
    if (polygon) {
      const coordsText = polygon.getElementsByTagName('coordinates')[0]?.textContent || ''
      const coords = coordsText
        .trim()
        .split(/\s+/)
        .filter(coord => coord.trim() !== '')
        .map(coord => {
          const [lng, lat] = coord.split(',').map(Number)
          return [lng, lat]
        })

      if (coords.length >= 3) {
        features.push({
          type: 'Feature',
          properties,
          geometry: {
            type: 'Polygon',
            coordinates: [coords]
          }
        })
      }
    }

    return features
  }

  _kmlToGeoJSON (kmlString) {
    const parser = new DOMParser()
    const kml = parser.parseFromString(kmlString, 'text/xml')

    const placemarks = kml.getElementsByTagName('Placemark')
    let features = []

    Array.from(placemarks).forEach(placemark => {
      const name = placemark.getElementsByTagName('name')[0]?.textContent || ''
      const description = placemark.getElementsByTagName('description')[0]?.textContent || ''
      const properties = { name, description }

      const multiGeometry = placemark.getElementsByTagName('MultiGeometry')[0]
      if (multiGeometry) {
        features = this._kmlMultiPolygonToGeoJSON(multiGeometry, properties)
      } else {
        features = this._kmlPolygonToGeoJson(placemark, properties)
      }
    })

    return {
      type: 'FeatureCollection',
      features
    }
  }

  async adapt () {
    if (this._isKml(this._file)) {
      try {
        const fileContent = await this._file.text()
        return this._kmlToGeoJSON(fileContent)
      } catch (error) {
        throw new Error(`Erro ao converter KML para GeoJSON: ${error}`)
      }
    }

    if (this._isZip(this._file)) {
      try {
        const data = await this._file.arrayBuffer()
        const geoJSON = await shp(data)

        return geoJSON
      } catch (error) {
        throw new Error(`Erro ao converter shapefile para GeoJSON: ${error}`)
      }
    }

    if (this._isGeoJSON(this._file)) {
      try {
        const fileContent = await this._file.text()
        return JSON.parse(fileContent)
      } catch (error) {
        throw new Error(`Erro ao converter GeoJSON para GeoJSON: ${error}`)
      }
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/components(new)/UI/Maps/core/geoJsonAdapter.js